import React from 'react';
import { Checkbox, Typography } from 'antd';
import { useIntl } from 'react-intl';
type Option = {
	id: string;
	text: string;
};

interface MultiSelectProps {
	options: Option[];
	value: string[];
	onChange: (val: string[]) => void;
	maxSelections?: number;
	error?: boolean;
	helperText?: string;
}

export const LimitedCheckboxGroup: React.FC<MultiSelectProps> = ({
	options,
	value,
	onChange,
	maxSelections,
	error,
	helperText,
}) => {
	const intl = useIntl();
	const handleChange = (checkedValues: any[]) => {
		if (maxSelections && checkedValues.length > maxSelections) {
			return;
		}
		onChange(checkedValues as string[]);
	};

	return (
		<div
			style={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: 6,
			}}
		>
			<div
				style={{
					width: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					flexWrap: 'wrap',
					gap: 8,
				}}
			>
				{options.map((option) => (
					<label
						key={option.id}
						htmlFor={`survey-option-${option.id}`}
						style={{ display: 'flex', gap: 4, alignItems: 'center', maxWidth: '100%' }}
					>
						<Checkbox
							id={`survey-option-${option.id}`}
							checked={value.includes(option.id)}
							onChange={(e) => {
								const checked = e.target.checked;
								let newValue = [...value];

								if (checked) {
									newValue = Array.from(new Set([...newValue, option.id]));
								} else {
									newValue = newValue.filter((v) => v !== option.id);
								}

								handleChange(newValue);
							}}
						/>
						<Typography.Text>{option.text}</Typography.Text>
					</label>
				))}
			</div>

			{maxSelections && (
				<Typography.Text type="secondary">
					{maxSelections === 1
						? intl.formatMessage({ id: 'survey_helper_max_selections_1' })
						: (intl.formatMessage(
								{ id: 'survey_helper_max_selections_2' },
								{ maxSelections },
						  ) as string)}
				</Typography.Text>
			)}

			{error && <Typography.Text type="danger">{helperText}</Typography.Text>}
		</div>
	);
};
